import React from 'react'
import { ListSubheader, Box, Typography, withStyles, ListItem } from '@material-ui/core'
import { getLang } from '../app/selectors/lang'
import SedaMetricSelectListHeader from './SedaMetricSelectListHeader'
import SedaMetricSelectListItem from './SedaMetricSelectListItem'
import HintIconButton from '../../../shared/components/Buttons/HintIconButton'
import {
  getMetricIdFromVarName,
  getVarNameWithUnit
} from '../app/selectors'
import { useMetric, useUnit } from '../app/hooks'

const styles = theme => ({
  learn: {
    paddingTop: 0,
    paddingLeft: theme.spacing(3),
    display: 'flex',
    '& .MuiSvgIcon-root': {
      marginRight: 5
    },
    '& .MuiIconButton-root:hover': {
      backgroundColor: 'transparent'
    },
    '& .MuiTypography-root': {
      textTransform: 'none',
      letterSpacing: 'normal',
      color: theme.palette.text.secondary,
    }
  }
})

const SedaMetricSelectList = ({ classes, location }) => {
  const [metric, setMetric] = useMetric()
  const [unit] = useUnit()
  const varGroupKeys = ['mth', 'ela', 'abs']
  const varGroupRanges = {
    mth: ['1922', '2224', '1924'],
    ela: ['1922', '2224', '1924'],
    abs: ['1923'],
  }

  const handleMetricSelect = varName => {
    const newMetric = getMetricIdFromVarName(varName)
    setMetric(newMetric)
  }

  return (
    <>
      <ListSubheader>
        {getLang('LOCATION_SUBHEADING_OVERALL')}
      </ListSubheader>
      <ListItem className={classes.learn}>
        <HintIconButton title={''} /> 
        <Typography
          component='a'
          href='/recovery/methods'
          target='_blank'
          variant='caption'
        >
          Learn how our methodology has changed
        </Typography>
      </ListItem>
      {varGroupKeys.map(varGroupKey =>
        <div key={varGroupKey}>
          <SedaMetricSelectListHeader
            key={varGroupKey}
            groupName={varGroupKey}
          />
          {
            varGroupRanges[varGroupKey].map(varGroupRange => {
            const varName = `all_${varGroupKey+varGroupRange}`
            const title = getLang('LABEL_' + varGroupRange)
            const selected = getMetricIdFromVarName(varName) === metric
            const value = location ?
              location[getVarNameWithUnit(varName, unit)]
            : null
            const interval = location ?
              location[getVarNameWithUnit(varName, unit) + '_e']
            : null
            return (
              <SedaMetricSelectListItem
                button
                key={varGroupRange}
                varName={varName}
                title={title}
                avatar={false}
                indent={true}
                selected={selected}
                value={value}
                interval={interval}
                onClick={() => handleMetricSelect(varName)}
              />
            )
          })
        }
        </div>
      )}
    </>
  )
}

SedaMetricSelectList.propTypes = {

}

export default withStyles(styles)(SedaMetricSelectList)
